import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="max-w-5xl mx-auto px-6 py-16">

        <h1 className="text-4xl font-bold text-gray-900 mb-3">
          Privacy Policy
        </h1>

        <p className="text-gray-500 mb-10">
          Last Updated: August 2026
        </p>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 md:p-12 space-y-10">

          <section>
            <p className="text-gray-700 leading-8">
              SQIT.ai ("we", "our", or "us"), a product of
              <strong> Bionivid Technology Pvt. Ltd.</strong>, is committed to
              protecting the privacy, confidentiality, and security of our users.
              This Privacy Policy explains how we collect, use, store, protect,
              and disclose personal information and scientific data when you use
              the SQIT.ai Bioinformatics Platform, website, and related services.
            </p>

            <p className="mt-5 text-gray-700 leading-8">
              By accessing or using our services, you acknowledge that you have
              read and understood this Privacy Policy and agree to its terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              1. Information We Collect
            </h2>

            <p className="text-gray-700 mb-4">
              We may collect information necessary to provide our services,
              including but not limited to:
            </p>

            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Personal identification information</li>
              <li>Organization and institutional details</li>
              <li>Contact information</li>
              <li>Account credentials</li>
              <li>Billing and payment information</li>
              <li>Scientific and bioinformatics datasets uploaded by users</li>
              <li>Technical usage logs and device information</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              2. How We Use Information
            </h2>

            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Provide bioinformatics analysis services.</li>
              <li>Process uploaded sequencing datasets.</li>
              <li>Generate analytical reports.</li>
              <li>Improve platform performance.</li>
              <li>Provide customer support.</li>
              <li>Maintain platform security.</li>
              <li>Comply with applicable legal requirements.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              3. Scientific Data Privacy
            </h2>

            <p className="text-gray-700 leading-8">
              SQIT.ai understands the confidential nature of biological and
              research datasets. Uploaded data remains the property of the user
              or organization. We use uploaded datasets solely for performing
              the requested computational analyses unless otherwise authorized by
              the customer.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              4. Data Security
            </h2>

            <p className="text-gray-700 leading-8">
              We implement appropriate technical and organizational safeguards
              including secure authentication, encrypted communication,
              role-based access control, infrastructure monitoring, and secure
              storage practices designed to protect user information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              5. Information Sharing
            </h2>

            <p className="text-gray-700 leading-8">
              We do not sell or rent personal information. Information may be
              shared only with authorized personnel, trusted service providers,
              or government authorities where legally required.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              6. Cookies
            </h2>

            <p className="text-gray-700 leading-8">
              Our website may use cookies and similar technologies to improve
              user experience, maintain sessions, remember preferences, and
              analyze website performance.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              7. User Rights
            </h2>

            <p className="text-gray-700 leading-8">
              Depending on applicable laws, users may request access,
              correction, deletion, or export of their personal information by
              contacting our support team.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              8. Data Retention
            </h2>

            <p className="text-gray-700 leading-8">
              Information is retained only for as long as necessary to provide
              services, comply with legal obligations, resolve disputes, and
              maintain business records.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              9. Changes to this Policy
            </h2>

            <p className="text-gray-700 leading-8">
              We may update this Privacy Policy periodically. Any revisions will
              be reflected on this page with an updated revision date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              10. Contact Us
            </h2>

            <div className="rounded-xl bg-green-50 border border-green-200 p-6">
              <p className="font-semibold text-lg">
                Bionivid Technology Pvt. Ltd.
              </p>

              <p className="mt-3">
                <strong>Platform:</strong> SQIT.ai™ Bioinformatics Platform
              </p>

              <p>
                <strong>Email:</strong> info@bionivid.com
              </p>

              <p>
                <strong>Phone:</strong> +91 95356 19191
              </p>

              <p className="mt-3">
                3rd Floor, Saanvi Complex,<br />
                28, Kattigenahalli,<br />
                Bengaluru, Karnataka 560064,<br />
                India
              </p>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
}